import WikiBox from '../../../../../common/components/WikiBox/WikiBox';

export default WikiBox;
